(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai3d-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ai3d-categories-carousel]';

    const init = (section) => {
      if (!section || section.dataset.categoriesCarouselReady === 'true') return;

      const viewport = section.querySelector('[data-ai3d-categories-viewport]');
      if (!viewport) return;

      section.dataset.categoriesCarouselReady = 'true';

      let activePointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let dragged = false;
      let suppressClick = false;

      const endDrag = () => {
        if (activePointerId === null) return;
        if (viewport.hasPointerCapture(activePointerId)) viewport.releasePointerCapture(activePointerId);
        activePointerId = null;
        viewport.classList.remove('is-dragging');
        suppressClick = dragged;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;
        dragged = false;
        viewport.setPointerCapture(activePointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (event.pointerId !== activePointerId) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) {
          dragged = true;
          viewport.classList.add('is-dragging');
        }
        viewport.scrollLeft = startScrollLeft - delta;
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      viewport.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const card = viewport.querySelector('.ai3d-categories__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(section).getPropertyValue('--categories-card-gap')) || 0;
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        event.preventDefault();
      });
    };

    const initAll = (root = document) => {
      root.querySelectorAll(selector).forEach(init);
    };

    initAll();
    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai3d-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-ai3d-collection-carousel]';

    const init = (section) => {
      if (!section || section.dataset.carouselReady === 'true') return;

      const viewport = section.querySelector('[data-ai3d-collection-carousel-viewport]');
      if (!viewport) return;

      section.dataset.carouselReady = 'true';

      let activePointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let dragged = false;
      let suppressClick = false;

      const endDrag = () => {
        if (activePointerId === null) return;
        if (viewport.hasPointerCapture(activePointerId)) viewport.releasePointerCapture(activePointerId);
        activePointerId = null;
        viewport.classList.remove('is-dragging');
        suppressClick = dragged;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
        activePointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;
        dragged = false;
        viewport.setPointerCapture(activePointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (event.pointerId !== activePointerId) return;
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 4) {
          dragged = true;
          viewport.classList.add('is-dragging');
        }
        viewport.scrollLeft = startScrollLeft - delta;
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('lostpointercapture', endDrag);

      viewport.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const card = viewport.querySelector('.ai3d-collection-carousel__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(section).getPropertyValue('--collection-carousel-gap')) || 0;
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        event.preventDefault();
      });
    };

    const initAll = (root = document) => {
      root.querySelectorAll(selector).forEach(init);
    };

    initAll();
    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai3d-craft-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-ai3d-craft-process]';

    const initialize = (section) => {
      if (!section || section.dataset.ai3dCraftReady === 'true') return;

      const track = section.querySelector('[data-ai3d-craft-track]');
      const cards = Array.from(section.querySelectorAll('[data-ai3d-craft-card]'));
      const buttons = Array.from(section.querySelectorAll('[data-ai3d-craft-step]'));
      const position = section.querySelector('[data-ai3d-craft-position]');

      if (!track || cards.length === 0) return;

      section.dataset.ai3dCraftReady = 'true';
      let activeIndex = 0;

      const updateActiveStep = () => {
        const trackLeft = track.getBoundingClientRect().left;
        activeIndex = cards.reduce((closestIndex, card, index) => {
          const currentDistance = Math.abs(cards[closestIndex].getBoundingClientRect().left - trackLeft);
          const nextDistance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);

        buttons.forEach((button, index) => {
          button.setAttribute('aria-pressed', String(index === activeIndex));
        });

        if (position) {
          position.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        }
      };

      const goToStep = (index) => {
        const nextIndex = Math.min(cards.length - 1, Math.max(0, index));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        track.scrollTo({
          left:
            track.scrollLeft +
            cards[nextIndex].getBoundingClientRect().left -
            track.getBoundingClientRect().left,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => goToStep(Number(button.dataset.ai3dCraftStep)));
      });

      track.addEventListener('scroll', updateActiveStep, { passive: true });
      track.addEventListener('keydown', (event) => {
        let nextIndex = activeIndex;

        if (event.key === 'ArrowRight') nextIndex += 1;
        else if (event.key === 'ArrowLeft') nextIndex -= 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = cards.length - 1;
        else return;

        event.preventDefault();
        goToStep(nextIndex);
      });

      updateActiveStep();
    };

    const initializeAll = (scope) => {
      if (scope.matches?.(sectionSelector)) initialize(scope);
      scope.querySelectorAll?.(sectionSelector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai3d-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ai3d-home-hero')) {
    class Ai3dHomeHero extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-carousel-ready')) return;

        this.setAttribute('data-carousel-ready', '');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.counter = this.querySelector('[data-carousel-counter]');
        this.toggleButton = this.querySelector('[data-carousel-toggle]');
        this.pauseIcon = this.querySelector('[data-carousel-pause]');
        this.playIcon = this.querySelector('[data-carousel-play]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplayDelay = Math.max(3000, Number(this.dataset.autoplayDelay) || 5000);
        this.manualPaused = this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;
        this.touchStart = null;
        this.suppressNextClick = false;
        this.suppressClickTimer = null;

        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onPointerEnter = this.stopAutoplay.bind(this);
        this.onPointerLeave = this.startAutoplay.bind(this);
        this.onFocusIn = this.stopAutoplay.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);

        this.showSlide(this.currentIndex);
        this.updateToggle();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeyDown);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.suppressClickTimer) window.clearTimeout(this.suppressClickTimer);
      }

      onClick(event) {
        if (this.suppressNextClick && event.target.closest('a')) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressNextClick = false;
          return;
        }

        const dot = event.target.closest('[data-carousel-dot]');
        if (dot) {
          this.showSlide(Number(dot.dataset.slideTo));
          this.restartAutoplay();
          return;
        }

        if (event.target.closest('[data-carousel-toggle]')) {
          this.manualPaused = !this.manualPaused;
          this.updateToggle();
          if (this.manualPaused) {
            this.stopAutoplay();
          } else {
            this.startAutoplay(true);
          }
        }
      }

      onKeyDown(event) {
        const dot = event.target.closest('[data-carousel-dot]');
        if (!dot || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        const currentDotIndex = this.dots.indexOf(dot);
        let nextIndex = currentDotIndex;
        if (event.key === 'ArrowLeft') nextIndex -= 1;
        if (event.key === 'ArrowRight') nextIndex += 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.dots.length - 1;
        nextIndex = ((nextIndex % this.dots.length) + this.dots.length) % this.dots.length;

        this.dots[nextIndex].focus();
        this.showSlide(nextIndex);
        this.restartAutoplay();
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      onBlockSelect(event) {
        const selectedSlide = event.target.closest('[data-hero-slide]');
        if (!selectedSlide || !this.contains(selectedSlide)) return;

        this.manualPaused = true;
        this.showSlide(Number(selectedSlide.dataset.slideIndex));
        this.updateToggle();
        this.stopAutoplay();
      }

      onTouchStart(event) {
        if (event.touches.length !== 1 || this.slides.length < 2) return;
        this.touchStart = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY
        };
      }

      onTouchEnd(event) {
        if (!this.touchStart || event.changedTouches.length === 0) return;

        const deltaX = event.changedTouches[0].clientX - this.touchStart.x;
        const deltaY = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

        this.suppressNextClick = true;
        if (this.suppressClickTimer) window.clearTimeout(this.suppressClickTimer);
        this.suppressClickTimer = window.setTimeout(() => {
          this.suppressNextClick = false;
          this.suppressClickTimer = null;
        }, 500);

        this.showSlide(this.currentIndex + (deltaX < 0 ? 1 : -1));
        this.restartAutoplay();
      }

      showSlide(index) {
        if (this.slides.length === 0) return;

        const normalizedIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        this.currentIndex = normalizedIndex;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === normalizedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
            if (isActive) {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', '-1');
            }
          });
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
          dot.setAttribute('aria-pressed', String(isActive));
        });

        if (this.counter) {
          const current = String(normalizedIndex + 1).padStart(2, '0');
          const total = String(this.slides.length).padStart(2, '0');
          this.counter.textContent = `${current} / ${total}`;
        }

        const activeSlide = this.slides[normalizedIndex];
        this.style.setProperty('--hero-control-current-color', activeSlide.dataset.controlColor || '#322c25');
        this.dataset.controlTheme = activeSlide.dataset.controlTheme || 'light';
      }

      startAutoplay(ignoreInteractionPause = false) {
        const isPointerPaused = window.matchMedia('(hover: hover)').matches && this.matches(':hover');
        const isFocusPaused = this.matches(':focus-within');
        if (this.manualPaused || document.hidden || this.slides.length < 2) return;
        if (!ignoreInteractionPause && (isPointerPaused || isFocusPaused)) return;

        this.stopAutoplay();
        this.timer = window.setInterval(() => this.showSlide(this.currentIndex + 1), this.autoplayDelay);
      }

      stopAutoplay() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      updateToggle() {
        if (!this.toggleButton) return;

        this.toggleButton.setAttribute('aria-pressed', String(this.manualPaused));
        this.toggleButton.setAttribute('aria-label', this.manualPaused ? 'Play slideshow' : 'Pause slideshow');
        if (this.pauseIcon) this.pauseIcon.hidden = this.manualPaused;
        if (this.playIcon) this.playIcon.hidden = !this.manualPaused;
      }
    }

    customElements.define('ai3d-home-hero', Ai3dHomeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const TAG_NAME = 'community-world-gallery';
    if (customElements.get(TAG_NAME)) return;

    class CommunityWorldGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        // Also works when the theme editor inserts/reorders a section.
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.initialized = true;
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.videos = Array.from(this.querySelectorAll('[data-preview]'));
        this.navigation = this.querySelector('[data-navigation]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.dialog = this.querySelector('[data-dialog]');
        this.viewerBody = this.querySelector('[data-viewer-body]');
        this.visibleVideos = new Set();
        this.pendingVideos = new WeakSet();
        this.blockedVideos = new WeakSet();
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.dataset.rtl = String(this.rtl);
        this.suppressClickUntil = 0;
        this.drag = null;

        const listen = (target, event, callback, options = {}) => {
          if (target) target.addEventListener(event, callback, { ...options, signal: this.signal });
        };
        listen(this.track, 'scroll', () => this.queueNavigation(), { passive: true });
        listen(this.track, 'keydown', (event) => this.onTrackKeydown(event));
        listen(this.track, 'pointerdown', (event) => this.onPointerDown(event));
        listen(window, 'pointermove', (event) => this.onPointerMove(event), { passive: false });
        listen(window, 'pointerup', (event) => this.endDrag(event));
        listen(window, 'pointercancel', (event) => this.endDrag(event));
        listen(window, 'blur', () => this.endDrag());
        listen(this.track, 'dragstart', (event) => event.preventDefault());
        listen(this.track, 'click', (event) => this.onTrackClick(event), { capture: true });
        listen(this.previous, 'click', () => this.scrollByCard(-1));
        listen(this.next, 'click', () => this.scrollByCard(1));
        listen(document, 'visibilitychange', () => this.syncVideos());
        listen(document, 'cwg:viewer-change', () => this.syncVideos());
        listen(this.motionQuery, 'change', () => this.syncVideos());
        listen(navigator.connection, 'change', () => this.syncVideos());
        listen(document, 'shopify:block:select', (event) => this.onBlockSelect(event));

        if (this.dialog) {
          listen(this.querySelector('[data-close]'), 'click', () => this.closeViewer());
          listen(this.dialog, 'close', () => this.releaseViewer());
          listen(this.dialog, 'cancel', (event) => {
            event.preventDefault();
            this.closeViewer();
          });
          // Close only when both ends of a click are outside the media panel.
          listen(this.dialog, 'pointerdown', (event) => {
            this.backdropPointerDown = event.target === this.dialog;
          });
          listen(this.dialog, 'click', (event) => {
            if (event.target === this.dialog && this.backdropPointerDown) this.closeViewer();
          });
        }

        this.videos.forEach((video) => {
          video.controls = false;
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('aria-hidden', 'true');
          video.setAttribute('tabindex', '-1');
          listen(video, 'play', () => this.updateVideoButton(video));
          listen(video, 'pause', () => this.updateVideoButton(video));
          listen(video, 'ended', () => this.updateVideoButton(video));
          listen(video, 'error', () => this.showVideoError(video));
          // A source failure does not consistently bubble to its video element.
          video.querySelectorAll('source').forEach((source) => {
            listen(source, 'error', () => this.showVideoError(video));
          });
          this.updateVideoButton(video);
        });

        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                this.visibleVideos.add(entry.target);
              } else {
                this.visibleVideos.delete(entry.target);
              }
            });
            this.syncVideos();
          }, { threshold: [0, 0.25, 0.5, 1] });
          this.videos.forEach((video) => this.mediaObserver.observe(video));
        } else {
          // Older browsers: allow intentional playback but never autoplay.
          this.videos.forEach((video) => this.visibleVideos.add(video));
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.queueNavigation());
          this.resizeObserver.observe(this.track);
        } else {
          listen(window, 'resize', () => this.queueNavigation(), { passive: true });
        }
        this.classList.add('is-ready');
        this.updateNavigation();
        this.syncVideos();
      }

      queueNavigation() {
        if (this.navFrame) return;
        this.navFrame = requestAnimationFrame(() => {
          this.navFrame = null;
          this.updateNavigation();
        });
      }

      updateNavigation() {
        if (!this.track) return;
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const offset = Math.abs(this.track.scrollLeft);
        this.track.classList.toggle('is-scrollable', this.maxScroll > 2);
        this.track.tabIndex = this.maxScroll > 2 ? 0 : -1;
        if (this.navigation) this.navigation.hidden = this.maxScroll <= 2;
        if (this.previous) this.previous.disabled = offset <= 2;
        if (this.next) this.next.disabled = offset >= this.maxScroll - 2;
      }

      scrollToOffset(offset, smooth = true) {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const target = Math.max(0, Math.min(offset, max));
        this.track.scrollTo({
          left: target * (this.rtl ? -1 : 1),
          behavior: smooth && !this.motionQuery.matches ? 'smooth' : 'auto'
        });
      }

      scrollByCard(direction) {
        const firstCard = this.cards[0];
        if (!firstCard) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = firstCard.getBoundingClientRect().width + gap;
        this.scrollToOffset(Math.abs(this.track.scrollLeft) + step * direction);
      }

      onTrackKeydown(event) {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.scrollByCard(direction * (this.rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollToOffset(event.key === 'Home' ? 0 : this.track.scrollWidth);
        }
      }

      onPointerDown(event) {
        // Touch scrolling remains completely native; vertical page scrolling is untouched.
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.maxScroll <= 2) return;
        if (event.target.closest('button')) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
      }

      onPointerMove(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        if (!this.drag.active) {
          if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
          this.drag.active = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - dx;
      }

      endDrag(event) {
        if (!this.drag || (event && event.pointerId !== this.drag.id)) return;
        if (this.drag.active) {
          this.suppressClickUntil = performance.now() + 350;
          if (this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        }
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.queueNavigation();
      }

      onTrackClick(event) {
        if (performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const toggle = event.target.closest('[data-preview-toggle]');
        if (toggle) {
          event.preventDefault();
          const video = toggle.closest('[data-card]').querySelector('[data-preview]');
          if (!video) return;
          if (!video.paused) {
            video.dataset.manualPaused = 'true';
            video.dataset.manualPlay = 'false';
            video.pause();
          } else {
            video.dataset.manualPaused = 'false';
            video.dataset.manualPlay = 'true';
            this.visibleVideos.add(video);
            this.blockedVideos.delete(video);
            if (video.error) video.load();
            this.tryPlay(video);
          }
          return;
        }
        const opener = event.target.closest('[data-open]');
        // Preserve modifier-clicks and the direct-media fallback without <dialog> support.
        if (!opener || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.openViewer(opener.closest('[data-card]'), opener);
      }

      shouldPlay(video) {
        if (!this.isConnected || document.hidden || CommunityWorldGallery.activeViewer) return false;
        if (!this.visibleVideos.has(video) || video.dataset.manualPaused === 'true') return false;
        if (this.blockedVideos.has(video)) return false;
        if (video.dataset.manualPlay === 'true') return true;
        return this.dataset.autoplay === 'true'
          && this.dataset.designMode !== 'true'
          && !this.motionQuery.matches
          && !navigator.connection?.saveData
          && 'IntersectionObserver' in window;
      }

      syncVideos() {
        this.videos?.forEach((video) => {
          if (this.shouldPlay(video)) this.tryPlay(video);
          else video.pause();
        });
      }

      tryPlay(video) {
        if (!this.shouldPlay(video) || !video.paused || this.pendingVideos.has(video)) return;
        this.pendingVideos.add(video);
        let promise;
        try { promise = video.play(); } catch (error) { promise = Promise.reject(error); }
        Promise.resolve(promise).catch((error) => {
          if (error.name !== 'AbortError') this.blockedVideos.add(video);
          this.updateVideoButton(video);
        }).finally(() => {
          this.pendingVideos.delete(video);
          // An asynchronous play request must not restart a hidden/removed video.
          if (!this.shouldPlay(video)) video.pause();
        });
      }

      updateVideoButton(video) {
        const card = video.closest('[data-card]');
        if (!card) return;
        const playing = !video.paused && !video.ended;
        card.classList.toggle('is-playing', playing);
        const button = card.querySelector('[data-preview-toggle]');
        if (button) {
          const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          button.setAttribute('aria-label', `${label}: ${card.dataset.title}`);
        }
        if (playing) {
          const error = card.querySelector('[data-video-error]');
          if (error) error.hidden = true;
        }
      }

      showVideoError(video) {
        this.blockedVideos.add(video);
        const error = video.closest('[data-card]')?.querySelector('[data-video-error]');
        if (error) error.hidden = false;
        this.updateVideoButton(video);
      }

      openViewer(card, opener) {
        const template = card?.querySelector('[data-viewer-template]');
        if (!template || !this.dialog || !this.viewerBody) return;
        if (CommunityWorldGallery.activeViewer) CommunityWorldGallery.activeViewer.closeViewer();
        this.returnFocus = opener;
        this.viewerBody.replaceChildren(template.content.cloneNode(true));
        this.dialog.setAttribute('aria-label', card.dataset.title);
        this.dialog.showModal();
        const root = document.documentElement;
        this.savedOverflow = { value: root.style.getPropertyValue('overflow'), priority: root.style.getPropertyPriority('overflow') };
        root.style.setProperty('overflow', 'hidden');
        CommunityWorldGallery.activeViewer = this;
        document.dispatchEvent(new Event('cwg:viewer-change'));
        const fullVideo = this.viewerBody.querySelector('video');
        if (fullVideo) {
          fullVideo.muted = false;
          // A user click initiated this request. Native controls remain on if playback is blocked.
          const play = fullVideo.play();
          if (play?.catch) play.catch(() => {});
        }
        this.querySelector('[data-close]')?.focus({ preventScroll: true });
      }

      closeViewer() {
        if (this.dialog?.open) this.dialog.close();
        this.releaseViewer();
      }

      releaseViewer() {
        // A queued close event can arrive after the next story has already opened.
        if (this.dialog?.open) return;
        this.viewerBody?.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          video.load();
        });
        this.viewerBody?.replaceChildren();
        if (CommunityWorldGallery.activeViewer !== this) return;
        CommunityWorldGallery.activeViewer = null;
        const root = document.documentElement;
        if (this.savedOverflow?.value) root.style.setProperty('overflow', this.savedOverflow.value, this.savedOverflow.priority);
        else root.style.removeProperty('overflow');
        this.savedOverflow = null;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
        document.dispatchEvent(new Event('cwg:viewer-change'));
      }

      onBlockSelect(event) {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        const card = this.cards.find((item) => item.dataset.blockId === String(event.detail?.blockId));
        if (!card) return;
        this.closeViewer();
        card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.navFrame);
        this.navFrame = null;
        this.closeViewer();
        this.abortController?.abort();
        this.mediaObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.videos?.forEach((video) => video.pause());
        this.classList.remove('is-ready');
        this.initialized = false;
        this.drag = null;
      }
    }

    CommunityWorldGallery.activeViewer = null;
    customElements.define(TAG_NAME, CommunityWorldGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
